import { fromEventPattern } from 'rxjs';

export * from './lib/end-right-sidenav.module';
export { EndRightButtonCloseComponent } from './lib/end-right-button-close/end-right-button-close.component';
export { EndRightSidenavBaseComponent } from './lib/end-right-sidenav-base/end-right-sidenav-base.component';
export { EndRightSidenavService } from './lib/end-right-sidenav.service';